import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { EnvService } from '../../services/env/env.service';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthenticationService,
        private envService: EnvService
    ) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        let sessionToken = null;
        if (
            request.urlWithParams.includes('driver/otp/') ||
            request.urlWithParams.includes('driver/status-change/') ||
            request.urlWithParams.includes('driver/verification-request/')
        ) {
            sessionToken = sessionStorage.getItem('driverAuthToken');
        }

        const isShipmentTracking = request.urlWithParams.includes('driver/shipment-tracking/');
        const token = isShipmentTracking ? null : (this.authService.getToken() || sessionToken);
        if (token) {
            const authReq = request.clone({
                setHeaders: { Authorization: `Token ${token}` },
            });
            return next.handle(authReq);
        }
        // Add X-WebFrontend-Version to existing headers
        request = request.clone({
            headers: request.headers.set(
                'X-WebFrontend-Version',
                this.envService.version
            ),
        });
        return next.handle(request);
    }
}
